import { Session } from "@stytch/vanilla-js";

/**
 * Pinned @stytch/vanilla-js (4.x) predates User Impersonation, so its
 * AuthenticationFactor union has no impersonated variant.
 * Drop once the SDK is upgraded
 */
interface ImpersonatedFactor {
  type?: string;
  delivery_method?: string;
  impersonated_factor?: {
    impersonator_id: string;
    impersonator_email_address: string;
  };
}

const findImpersonatedFactor = (
  session: Session | null | undefined,
): ImpersonatedFactor | undefined =>
  (session?.authentication_factors as ImpersonatedFactor[] | undefined)?.find(
    (factor) => factor?.type === "impersonated",
  );

export const isImpersonatedSession = (session: Session | null | undefined) =>
  !!findImpersonatedFactor(session);

export const getImpersonatorEmail = (session: Session | null | undefined) =>
  findImpersonatedFactor(session)?.impersonated_factor
    ?.impersonator_email_address ?? null;

export const IMPERSONATION_TOKEN_TYPE = "impersonation";

// handoff in `_auth` passes token through history state rather than search params,
// so it only ever appears in the one url stytch sends
declare module "@tanstack/history" {
  interface HistoryState {
    impersonationToken?: string;
  }
}

export const readImpersonationToken = (search: string): string | null => {
  const params = new URLSearchParams(search);

  if (params.get("stytch_token_type") !== IMPERSONATION_TOKEN_TYPE) return null;

  return params.get("token");
};
